import { AssetMappingConfigurationBase } from './base/asset-mapping-configuration-base';

export class AssetMappingConfiguration extends AssetMappingConfigurationBase { }